import * as React from 'react';
import DownloadService from 'services/DownloadService';
const DownloadContext = React.createContext(new DownloadService({ authorizedFetch: (request) => fetch(request) }));
export default DownloadContext;
